export class CampaignTemplateService {
  constructor($http) {
    this.http = $http;
  }

  getCampaignTemplate(id) {
    return this.http.get('/api/campaign-template/gettemplate/'+id)
  }

  getCampaignTemplateList(page, limit) {
    return this.http.get('/api/campaign-template-list/' + page + '/' + limit);
  }

  getCampaignTemplateNames() {
    return this.http.get('/api/campaign-template/getnames');
  }

  createCampaignTemplate(campaignTemplate) {
    return this.http.post('/api/campaign-template', campaignTemplate);
  }

  updateCampaignTemplate(campaignTemplate) {
    return this.http.put('/api/campaign-template/' + campaignTemplate._id, campaignTemplate)
  }

  removeCampaignTemplate(id) {
    return this.http.delete('/api/campaign-template/' + id)
  }
}
